var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9712 23.6569C34.2138 23.6569 33.5998 24.2709 33.5998 25.0283V38.7426C33.5998 39.5001 34.2138 40.1141 34.9712 40.1141H40.4569C41.2144 40.1141 41.8284 39.5001 41.8284 38.7426V25.0283C41.8284 24.2709 41.2144 23.6569 40.4569 23.6569H34.9712ZM30.8569 25.0283C30.8569 22.7561 32.699 20.9141 34.9712 20.9141H40.4569C42.7292 20.9141 44.5712 22.7561 44.5712 25.0283V38.7426C44.5712 41.0149 42.7292 42.8569 40.4569 42.8569H34.9712C32.699 42.8569 30.8569 41.0149 30.8569 38.7426V25.0283Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3999 41.4847C14.3999 40.7273 15.0139 40.1133 15.7713 40.1133H26.7428C27.5002 40.1133 28.1142 40.7273 28.1142 41.4847C28.1142 42.2421 27.5002 42.8561 26.7428 42.8561H15.7713C15.0139 42.8561 14.3999 42.2421 14.3999 41.4847Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42871 11.3138C3.42871 8.28416 5.88475 5.82812 8.91443 5.82812H33.6001C36.6298 5.82812 39.0859 8.28416 39.0859 11.3138V22.2853C39.0859 23.0427 38.4718 23.6567 37.7144 23.6567C36.957 23.6567 36.343 23.0427 36.343 22.2853V11.3138C36.343 9.799 35.115 8.57098 33.6001 8.57098H8.91443C7.39959 8.57098 6.17157 9.799 6.17157 11.3138V33.2567C6.17157 34.7715 7.39959 35.9996 8.91443 35.9996H32.2287C32.9861 35.9996 33.6001 36.6136 33.6001 37.371C33.6001 38.1284 32.9861 38.7424 32.2287 38.7424H8.91443C5.88475 38.7424 3.42871 36.2864 3.42871 33.2567V11.3138Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/device-icon.5bfd392c.svg";
export { ForwardRef as ReactComponent };